<template>
  <div class="player">
    <ul>
      <li id="top">
        <div class="toggle-tutton-wraper" @click="fourCount=!fourCount">
          <toggle-button
            v-model="fourCount"
            :sync="true"
            :width="84"
            :labels="{checked: 'FourCount', unchecked: 'Disabled'}"/>
          <span>再生前に<br>4カウントします</span>
        </div>
        <div class="toggle-tutton-wraper" @click="slowdown=!slowdown">
          <toggle-button
            v-model="slowdown"
            :sync="true"
            :width="84"
            :labels="{checked: 'SlowDown', unchecked: 'Disabled'}"/>
          <span>再生時に<br>スロー再生します</span>
        </div>
        <play
          :isPlaying="isPlaying"
          @start="start"
          @stop="stop"></play>
      </li>
      <li id="tempo"><tempo></tempo></li>
      <li id="metronome">
        <metronome
          :madeRhythm="madeRhythm"
          :metronome="metronome"
          @isRhythmChange="isRhythmChange"
          @isMetronomeChange="isMetronomeChange"></metronome>
        </li>

    </ul>
  </div>
</template>

<script>
import play from './button/play.vue'
import tempo from './button/tempo.vue'
import { ToggleButton } from 'vue-js-toggle-button'
import metronome from './button/metronome.vue'
export default {
  name: 'player',
  components: {
    play,
    tempo,
    ToggleButton,
    metronome
  },
  data: function(){
    return{
      slowdown: false,
      madeRhythm: true,
      metronome: true,
      fourCount: true,
      isPlaying: false,
      audiocontext: null,
      timer: null,
    }
  },
  mounted: function (){
    const AudioContext = window.AudioContext || window.webkitAudioContext;
    this.audiocontext = new AudioContext();
  },
  methods: {
    isRhythmChange: function(e){
      this.madeRhythm = e;
    },
    isMetronomeChange: function(e){
      this.metronome = e;
    },
    start: function(){
      this.isPlaying = true;
      const tones = [
        {'frequency': 523.251, 'volume': 1, 'type': 'sine'},// metronome low
        {'frequency': 783.991, 'volume': 1, 'type': 'sine'},// metronome high
        {'frequency': 659.255, 'volume': 0.5, 'type': 'square'},// rhythm
      ];
      const noteLength = 0.05;
      const release = 0.07;
      const makeSound = (tone, time) => {
        // console.log(time);
        const osc = new OscillatorNode(this.audiocontext);
        const vol = new GainNode(this.audiocontext);
        osc.connect(vol);
        vol.connect(this.audiocontext.destination);
        osc.type = tone.type;
        osc.frequency.value = tone.frequency;
        vol.gain.cancelScheduledValues(time);
        vol.gain.setValueAtTime(tone.volume, time);

        osc.start(time);
        vol.gain.linearRampToValueAtTime(0, time + noteLength + release);
        osc.stop(time + noteLength + release);
      }

      //variables
      let tracktime = 0;//3840単位
      let seconds = this.audiocontext.currentTime + 0.1;//秒単位
      let metCount = 0;
      
      //functions
      const metTone = () => Number(metCount % 4 === 0);
      const notesInRange = tracktime => {
        //tracktime=0 なら、0~960までの音を出すものをピックアップする
        return this.$store.state.score.filter(note => {
          return note.onoff && !note.tie && (tracktime <= note.start) && (note.start < (tracktime + 960));
          });
      }
      const generateSecondFromTrackTime = tracktime => {
        //単位変換, tracktimeから秒に変換する
        return tracktime / (this.playTempo * 16);
      }

      //はじめの4カウント
      if (this.fourCount) {
        for (let i = 0; i < 4; i++) {
          makeSound(tones[metTone()], seconds + this.oneBeatSecond * i);
          metCount += 1;
        }
        seconds += this.oneBeatSecond * 4;
      }

      //はじめの1拍目だけ発火
      //メトロノーム
      if (this.metronome) {
        makeSound(tones[metTone()], seconds);
      }
      metCount += 1;
      //入力されたリズム
      if (this.madeRhythm) {
        for (let note of notesInRange(0)) {
          makeSound(tones[2], seconds + generateSecondFromTrackTime(note.start));
        }
      }
      //1拍分
      tracktime += 960;//tracktime

      //interval timer
      this.timer = setInterval(() => {
        if (seconds < this.audiocontext.currentTime) {
          //メトロノーム
          if (this.metronome) {makeSound(tones[metTone()], seconds + this.oneBeatSecond)}
          metCount += 1;
          metCount %= 4;

          //音符
          if (this.madeRhythm) {
            for (let note of notesInRange(tracktime)) {
              makeSound(tones[2], seconds + generateSecondFromTrackTime(note.start - tracktime + 960));
            }
          }

          //finally
          tracktime += 960;
          tracktime %= (this.$store.getters.boxNum * 3840);
          seconds += this.oneBeatSecond;
        }
      }, 50);

    },
    stop: function(){
      this.isPlaying = false;
      clearInterval(this.timer);
      this.audiocontext.suspend().then(() => {
        this.audiocontext = new AudioContext();
      });
    }
  },
  computed: {
    playTempo: function (){//スロー再生を考慮したテンポ
      return this.$store.state.tempo / (1 + 0.5 * this.slowdown);
    },
    oneBeatSecond: function (){//一拍の時間
      return 60 / this.playTempo;
    },
  }
}
</script>

<style scoped>
.player{
  display: flex;
  flex-direction: row;
  justify-content: center;
  height: 264px;
  padding: 4px 0;
}
.player ul{
  position: relative;
  display: flex;
  flex-direction: column;
	padding: 0;
	margin: 0;
  width: 360px;
	list-style: none;
}
.player ul li{
  display: flex;
  position: relative;
  margin: 2px;
  padding: 0;
  height: 85px;
  background-color: #fff;
  border-radius: 10px;
}
#top div{
  display: block;
  position: relative;
  width: 33%;
}
.toggle-tutton-wraper{
  display: block;
  text-align: center;
  padding: 8px;
}
.toggle-tutton-wraper > span{
  display: inline-block;
  color: #333;
  font-size: 0.65rem;
}
</style>
